<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'App',
    mounted() {
        window.onbeforeunload = (e) => {
            Cookies.remove('token')

            // e = e || window.event
            // if (e) {
            //     e.returnValue = '关闭提示'
            // }

            // this.toCloseFun() //调用自己的方法

            // // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
            // return '关闭提示'
        }
    }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
html,
body {
    margin: 0;
    padding: 0;
}
html {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.el-carousel.el-carousel--horizontal {
    overflow: hidden !important;
}
/* body {
  background-image: url("./assets/11.gif");
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue